import React from "react";
import { Helmet } from "react-helmet-async";
import { useRef } from "react";
import { useEffect } from "react";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "./components/Header";
import HeroBanner from "./components/HeroBanner";
import MenuSection from "./components/MenuSection";
import TruckDiaries from "./components/TruckDiaries";
import LocationsSection from "./components/LocationsSection";
import OurStory from "./components/OurStory";
import ConnectedSection from "./components/ConnectedSection";
import Footer from "./components/Footer";
import ReviewsSection from "./components/ReviewsSection";

function App() {
  const aosInit = useRef(false);

  useEffect(() => {
    if (aosInit.current) return;

    AOS.init({
      duration: 1000, // animation speed
      easing: "ease-in-out", // smooth easing
      once: false, // trigger every time you scroll
      mirror: true, // animate back out when scrolling up
      offset: 100, // distance before triggering
    });

    aosInit.current = true;
  }, []);

  return (
    <>
      <Helmet>
        <title>StreetEats Food Truck | Gourmet Street Food on the Go</title>
        <meta
          name="description"
          content="StreetEats serves up mouthwatering gourmet street food made fresh daily. Find our food truck near you for tacos, burgers, and local favorites!"
        />
        <link rel="canonical" href="/templates/food-truck/" />
        <meta
          property="og:title"
          content="StreetEats Food Truck | Fresh, Fast, and Flavorful"
        />
        <meta
          property="og:description"
          content="Follow the StreetEats food truck and enjoy handcrafted street food made with local ingredients. Taste the difference wherever we roll!"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="/templates/food-truck/images/og-image.jpg"
        />
        <meta property="og:url" content="/templates/food-truck/" />
      </Helmet>

      
      <Header />
      <HeroBanner />
      <MenuSection />
      <TruckDiaries />
      <LocationsSection />
      <OurStory />
      <ReviewsSection />
      <ConnectedSection />
      <Footer />
    </>
  );
}

export default App;
